module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "note-reader"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_c('em', [_c('span', {
    staticClass: "dropcap1"
  }, [_vm._v("A")])]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE TO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADERS")])])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('em', [_vm._v("D")])]), _vm._v("uring the Regency period, a number of famous actors and actresses performed at Drury Lane theaters. One of the most notable was Sarah Siddons. Although Mrs. Siddons retired in 1812, near the beginning of the Regency period, she was the standard by which most actresses were judged for decades afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Actresses occupied a very difficult position, as acting was only just becoming a respected profession. Famed actors and actresses mixed with the literary and social elites, and were often hired to perform scenes and even entire plays at various social gatherings. Unfortunately, actresses were also preyed upon by the wealthy and indolent for far more notorious purposes, and many younger actresses were lured from the stage for less than respectable reasons.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("There are many stories about Sarah Siddons’s ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("acting abilities, and one of my favorites is when she played Asphasia in "), _c('em', [_vm._v("Tamburlaine")]), _vm._v(". After witnessing her stage lover strangled before her very eyes, Mrs. Siddons was supposed to fall lifeless upon the floor. Her performance was so gripping that members of the audience thought she’d really dropped dead, and raised a horrendous cry until the manager assured them that she’d only been acting and was, in fact, quite alive.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b0d8f08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/note-reader.vue
// module id = 81
// module chunks = 0